import { z } from './utils/zod.js';
// Same set as the notaries app. L and M are exactly the former LEGACY and
// COMPACT stamps, so signings migrated from those render unchanged.
export const stampSizeSchema = z.enum(['S', 'M', 'L']);
/** Stamp box per size in PDF points. */
export const STAMP_SIZES = {
    S: { width: 183, height: 45, lineOffset: 32.5 },
    M: { width: 183, height: 79.1, lineOffset: 67 },
    L: { width: 183, height: 94.5, lineOffset: 82 },
};
/**
 * A field's top edge (PDF points from the page top) after a size change. The
 * bottom edge stays put so the stamp keeps sitting on its signature line; a
 * stamp that would grow past the page top starts at the top instead.
 */
export const reanchorStampY = (y, from, to) => Math.max(0, y + STAMP_SIZES[from].height - STAMP_SIZES[to].height);
